import React, { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import ViewCompanyDetails from './ViewCompanyDetails';

const AddCompany = lazy(() => import('../contentCompanies/AddCompany'));
const ViewCompanies = lazy(() => import('../contentCompanies/ViewCompanies'));
const ContentCompaniesModule = () => {
  return (
    <div>
      <Suspense fallback={null}>
        <Routes>
          <Route path="addCompany" element={<AddCompany />} />
          <Route path="viewCompanies" element={<ViewCompanies />} />
          <Route path="viewDetailsCompanies" element={<ViewCompanyDetails />} />
        </Routes>
      </Suspense>
    </div>
  );
};

export default ContentCompaniesModule;
